
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import AsnModule from "@/store/modules/asn";
import { getModule } from "vuex-module-decorators";
import { ProcessAsnResponse } from "@/models/api/asn/process";

const asnModule = getModule(AsnModule);

interface DeliveryForOption {
  label: string;
  value: number;
}

@Component
export default class ImportCompletedModal extends Vue {
    @Prop()
    IsLoading: boolean;

    @Prop()
    Imported: ProcessAsnResponse;

    @Prop()
    DeliveryFor: number;

    @Prop()
    DeliveryFors: DeliveryForOption[];

    IsAgent: boolean = false;

    getDeliveryForName(deliveryForId){
        for(let i = 0; i < this.DeliveryFors.length; i++){
            if (this.DeliveryFors[i].value == deliveryForId){
                return this.DeliveryFors[i].label;
            }
        }

        return deliveryForId;
    }
}
